import { render } from "./MessageInbox.vue?vue&type=template&id=151a12ec&scoped=true"
import script from "./MessageInbox.vue?vue&type=script&lang=js"
export * from "./MessageInbox.vue?vue&type=script&lang=js"

import "./MessageInbox.vue?vue&type=style&index=0&id=151a12ec&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-151a12ec"]])

export default __exports__